// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warningText[data-v-3a9f78d2] {\n  margin-bottom: 32px;\n  border-radius: 8px;\n  border: 1px solid rgba(26, 123, 238, 0.2);\n  background: #eaefff;\n  width: 100%;\n  line-height: normal;\n  padding: 8px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
